exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divTituloModal,\n.modalFooter {\n  background-color: #f0f0f5; }\n\n.modal-demo {\n  background-color: #eee; }\n  .modal-demo .modal {\n    z-index: 0;\n    position: relative;\n    display: block; }\n\n.tituloModal {\n  font-size: 16px;\n  font-weight: normal; }\n\n.divTituloModal {\n  padding: 17px; }\n\n.modalBody {\n  padding: 6% 0px;\n  margin-bottom: -6%; }\n\n.modalFooter {\n  padding: 10px 30px;\n  margin-top: 5%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: end;\n      justify-content: flex-end; }\n\n.botao {\n  border-color: #f0f0f5; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/modal/modal.component.scss
// module id = ../../../../../src/app/angular-base-ui/modal/modal.component.scss
// module chunks = 1